// retype interfaces
// delete when `react-virtual` accepts this PR: https://github.com/TanStack/react-virtual/pull/277
import { useVirtual as useVirtualReactVirtual, defaultRangeExtractor } from 'react-virtual';
const useVirtual = useVirtualReactVirtual;
export { defaultRangeExtractor, useVirtual };
